import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  embedConfigs: {}, // Store configs by keyword
  loadedDashboards: new Set(), // Track which dashboards are loaded
  currentKeyword: null,
  error: null,
};

const PowerBI = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_POWERBI_EMBED_CONFIG:
      return { 
        ...state, 
        loading: true, 
        error: null,
        currentKeyword: action.keyword 
      };
      
    case actionTypes.FETCH_POWERBI_EMBED_CONFIG_SUCCESS:
      const newLoadedDashboards = new Set(state.loadedDashboards);
      newLoadedDashboards.add(action.keyword);
      
      return { 
        ...state, 
        loading: false, 
        embedConfigs: {
          ...state.embedConfigs,
          [action.keyword]: action.payload
        },
        loadedDashboards: newLoadedDashboards,
        // Set current embedConfig for backward compatibility
        embedConfig: action.payload
      };
      
    case actionTypes.FETCH_POWERBI_EMBED_CONFIG_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };
      
    case actionTypes.REFRESH_POWERBI_EMBED_TOKEN_SUCCESS:
      const updatedConfigs = { ...state.embedConfigs };
      // Update token for current keyword
      if (state.currentKeyword && updatedConfigs[state.currentKeyword]) {
        updatedConfigs[state.currentKeyword] = {
          ...updatedConfigs[state.currentKeyword],
          embedToken: action.payload
        };
      }
      
      return {
        ...state,
        embedConfigs: updatedConfigs,
        // Update current embedConfig for backward compatibility
        embedConfig: state.currentKeyword ? updatedConfigs[state.currentKeyword] : state.embedConfig
      };
      
    case actionTypes.REFRESH_POWERBI_EMBED_TOKEN_FAILURE:
      return { 
        ...state, 
        error: action.error 
      };
      
    case actionTypes.SET_CURRENT_DASHBOARD:
      return {
        ...state,
        currentKeyword: action.keyword,
        embedConfig: state.embedConfigs[action.keyword] || null
      };
      
    case actionTypes.RESET_DASHBOARD_CACHE:
      const resetLoadedDashboards = new Set(state.loadedDashboards);
      if (action.keyword) {
        resetLoadedDashboards.delete(action.keyword);
        const { [action.keyword]: removed, ...remainingConfigs } = state.embedConfigs;
        return {
          ...state,
          embedConfigs: remainingConfigs,
          loadedDashboards: resetLoadedDashboards
        };
      } else {
        // Reset all
        return {
          ...state,
          embedConfigs: {},
          loadedDashboards: new Set(),
          embedConfig: null
        };
      }
      
    default:
      return state;
  }
};

export default PowerBI;